(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("6ph3s", function(module, exports) {
    $parcel$export(module.exports, "default", function() {
      return $4aa24e9d49d5ff32$export$2e2bcd8739ae039;
    });
    var $7bS3h = parcelRequire("7bS3h");
    const $4aa24e9d49d5ff32$var$formatPrice = (amount, currencyCode) => {
      const needsCode = [ "USD", "CAD", "AUD", "HKD", "SGD", "NZD", "SEK", "DKK", "NOK", "CHF" ].includes(currencyCode);
      const needsSymbol = [ "USD", "CAD", "AUD", "HKD", "SGD", "NZD" ].includes(currencyCode);
      if (needsCode) {
        const symbol = needsSymbol ? "$" : "";
        const formattedAmount = (0, $7bS3h.default)(amount, "{{amount_no_decimals}}");
        return `${symbol}${formattedAmount} <span class="text-3xs">${currencyCode}</span>`;
      }
      return (0, $7bS3h.default)(amount, Shopify.money_format).replace(/\.00$/, "");
    };
    var $4aa24e9d49d5ff32$export$2e2bcd8739ae039 = $4aa24e9d49d5ff32$var$formatPrice;
  });
  parcelRegister("7bS3h", function(module, exports) {
    $parcel$export(module.exports, "default", function() {
      return $53c37d114b9030f9$export$2e2bcd8739ae039;
    });
    function $53c37d114b9030f9$export$2e2bcd8739ae039(cents, format) {
      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || window.Shopify?.money_format || "${{amount}}";
      const defaultOption = (opt, def) => typeof opt === "undefined" ? def : opt;
      const formatWithDelimiters = (number, precision, thousands, decimal) => {
        const resolvedPrecision = defaultOption(precision, 2);
        const resolvedThousands = defaultOption(thousands, ",");
        const resolvedDecimal = defaultOption(decimal, ".");
        if (isNaN(number) || number == null) return 0;
        const fixed = (number / 100).toFixed(resolvedPrecision);
        const parts = fixed.split(".");
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + resolvedThousands);
        const centsPart = parts[1] ? resolvedDecimal + parts[1] : "";
        return dollars + centsPart;
      };
      let normalized = cents;
      if (typeof normalized === "string") normalized = normalized.replace(".", "");
      const match = formatString.match(placeholderRegex);
      const token = match ? match[1] : "amount";
      switch (token) {
       case "amount":
        value = formatWithDelimiters(normalized, 2);
        break;

       case "amount_no_decimals":
        value = formatWithDelimiters(normalized, 0);
        break;

       case "amount_with_comma_separator":
        value = formatWithDelimiters(normalized, 2, ".", ",");
        break;

       case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(normalized, 0, ".", ",");
        break;

       default:
        value = formatWithDelimiters(normalized, 2);
        break;
      }
      return formatString.replace(placeholderRegex, value).replace(/(\.|,)00$/g, "");
    }
  });
  parcelRegister("dM4ny", function(module, exports) {
    $parcel$export(module.exports, "addToCart", function() {
      return $a07327994fef2925$export$576b6dd9d68b37bc;
    });
    $parcel$export(module.exports, "changeCartItem", function() {
      return $a07327994fef2925$export$ededa44e5413fe65;
    });
    function $a07327994fef2925$var$resolve() {
      if (!window.MBF?.cart) console.warn("[cart] window.MBF.cart is not initialised yet");
      const c = window.MBF?.cart;
      if (!c) throw new Error("[cart] not initialised");
      return c;
    }
    const $a07327994fef2925$export$576b6dd9d68b37bc = (input, opts) => $a07327994fef2925$var$resolve().add(input, opts);
    const $a07327994fef2925$export$ededa44e5413fe65 = (data, opts) => $a07327994fef2925$var$resolve().change(data, opts);
    const $a07327994fef2925$export$edba26a5417c3f39 = (data, opts) => $a07327994fef2925$var$resolve().update(data, opts);
    const $a07327994fef2925$export$3c1cc9429c2b6cf3 = opts => $a07327994fef2925$var$resolve().get(opts);
    const $a07327994fef2925$export$1688fd4de852c854 = () => $a07327994fef2925$var$resolve().get().then(c => c.item_count);
  });
  parcelRegister("9e4lR", function(module, exports) {
    $parcel$export(module.exports, "MODAL_OPEN_REQUEST_EVENT", function() {
      return $6b78cbfbaadac19a$export$3a3ec5884c2bdab0;
    });
    $parcel$export(module.exports, "MODAL_OPENED_EVENT", function() {
      return $6b78cbfbaadac19a$export$16a5d99daeabc70f;
    });
    $parcel$export(module.exports, "MODAL_OPEN_FAILED_EVENT", function() {
      return $6b78cbfbaadac19a$export$3e10ac5c14d1b477;
    });
    $parcel$export(module.exports, "createModalRequestId", function() {
      return $6b78cbfbaadac19a$export$6966a06f04e186a1;
    });
    const $6b78cbfbaadac19a$export$3a3ec5884c2bdab0 = "mbf:modal-open-request";
    const $6b78cbfbaadac19a$export$16a5d99daeabc70f = "mbf:modal-opened";
    const $6b78cbfbaadac19a$export$3e10ac5c14d1b477 = "mbf:modal-open-failed";
    function $6b78cbfbaadac19a$export$6966a06f04e186a1() {
      return window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
    function $6b78cbfbaadac19a$export$dee6409cd6d872a1(detail = {}) {
      const {requestId: requestId = null, baseUrl: baseUrl = null, url: url = null, view: view = null, strategy: strategy = null, context: context = null, modalId: modalId = null, source: source = null} = detail;
      return {
        requestId: requestId,
        baseUrl: baseUrl,
        url: url,
        view: view,
        strategy: strategy,
        context: context,
        modalId: modalId,
        sourceType: source?.type || null,
        sourceId: source?.id || null
      };
    }
  });
  parcelRegister("hdTUn", function(module, exports) {
    $parcel$export(module.exports, "getModalOrchestratorReadiness", function() {
      return $c89f04cac0ca9284$export$b6ddc94bcaaa5fb;
    });
    function $c89f04cac0ca9284$var$getModalState() {
      return window.MBF && typeof window.MBF === "object" ? window.MBF : null;
    }
    function $c89f04cac0ca9284$export$b6ddc94bcaaa5fb() {
      const state = $c89f04cac0ca9284$var$getModalState();
      const isInitialised = Boolean(state?.modalOrchestratorInitialised);
      if (isInitialised) return {
        ready: true,
        reason: null
      };
      return {
        ready: false,
        reason: "modal-orchestrator-not-initialized"
      };
    }
  });
  parcelRegister("5SWup", function(module, exports) {
    $parcel$export(module.exports, "isSwymBisAvailable", function() {
      return $448f5dad87ede000$export$cac796225ff578aa;
    });
    $parcel$export(module.exports, "onSwymBisAvailable", function() {
      return $448f5dad87ede000$export$858bae1b764ca9ee;
    });
    $parcel$export(module.exports, "subscribeForBackInStock", function() {
      return $448f5dad87ede000$export$65a9154226ebdd85;
    });
    var $YjNU1 = parcelRequire("YjNU1");
    function $448f5dad87ede000$var$isBisEnabledBySetting() {
      if (typeof window === "undefined") return false;
      return window.MBF?.settings?.enableBackInStock === true;
    }
    function $448f5dad87ede000$var$getRuntime() {
      if (!$448f5dad87ede000$var$isBisEnabledBySetting()) return null;
      return (0, $YjNU1.initSwymBis)();
    }
    const $448f5dad87ede000$export$597311bb5a89b43c = () => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      return runtime ? runtime.ready() : Promise.resolve();
    };
    const $448f5dad87ede000$export$cac796225ff578aa = () => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      return runtime ? runtime.isAvailable() : false;
    };
    const $448f5dad87ede000$export$858bae1b764ca9ee = callback => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      return runtime ? runtime.onAvailable(callback) : () => {};
    };
    const $448f5dad87ede000$export$65a9154226ebdd85 = args => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      if (!runtime) return Promise.reject(new Error("[swym-bis] disabled by theme setting enable_back_in_stock"));
      return runtime.subscribeForBackInStock(args);
    };
  });
  parcelRegister("YjNU1", function(module, exports) {
    $parcel$export(module.exports, "initSwymBis", function() {
      return $0b54f75990233cb1$export$23cdde14ed5ac142;
    });
    const $0b54f75990233cb1$var$ALLOWED_MEDIA = new Set([ "email", "sms" ]);
    const $0b54f75990233cb1$var$REQUIRED_PRODUCT_FIELDS = [ "epi", "empi", "du", "pr", "iu" ];
    const $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC = "backinstock";
    const $0b54f75990233cb1$var$MAILING_LIST_DISABLED_MESSAGE = "Swym mailing list opt-in is not enabled. Enable the mailing list feature in the Swym dashboard and the theme setting before sending addToMailingList: 1.";
    const $0b54f75990233cb1$var$MAILING_LIST_DISABLED_USER_MESSAGE = "Newsletter opt-in is not available right now. Untick the newsletter box and try again.";
    function $0b54f75990233cb1$var$deferCallback(callback) {
      if (typeof queueMicrotask === "function") {
        queueMicrotask(callback);
        return;
      }
      Promise.resolve().then(callback);
    }
    function $0b54f75990233cb1$var$normalizeSwymSuccessArgs(args) {
      if (!Array.isArray(args) || args.length === 0) return null;
      if (args.length === 1) return args[0];
      return args;
    }
    function $0b54f75990233cb1$var$stringifySwymCallbackValue(value) {
      if (value instanceof Error) return value.message || value.name || "Error";
      if (typeof value === "string") return value.trim() || "empty string";
      if (value === undefined) return "undefined";
      if (value === null) return "null";
      try {
        return JSON.stringify(value);
      } catch (_error) {
        return Object.prototype.toString.call(value);
      }
    }
    function $0b54f75990233cb1$var$getSwymObjectMessage(value) {
      const message = value.message || value.error || value.msg || value.description;
      if (typeof message === "string" && message.trim()) return message.trim();
      if (message && typeof message === "object") return $0b54f75990233cb1$var$stringifySwymCallbackValue(message);
      const responseText = value.responseText || value.response?.text;
      if (typeof responseText === "string" && responseText.trim()) try {
        const parsed = JSON.parse(responseText);
        return $0b54f75990233cb1$var$getSwymObjectMessage(parsed) || $0b54f75990233cb1$var$stringifySwymCallbackValue(parsed);
      } catch (_error) {
        return responseText.trim();
      }
      return "";
    }
    function $0b54f75990233cb1$var$normalizeSwymErrorArgs(args, context = {}) {
      const values = Array.isArray(args) ? args : [ args ];
      const firstDefined = values.find(value => value !== undefined && value !== null);
      const callbackArgs = values.map($0b54f75990233cb1$var$stringifySwymCallbackValue).join(", ");
      const contextDetails = Object.entries(context).filter(([, value]) => value !== undefined && value !== null && value !== "").map(([key, value]) => `${key}: ${$0b54f75990233cb1$var$stringifySwymCallbackValue(value)}`).join(", ");
      const suffixParts = [];
      if (callbackArgs) suffixParts.push(`callback args: ${callbackArgs}`);
      if (contextDetails) suffixParts.push(`request: ${contextDetails}`);
      const withDetails = message => {
        const normalizedMessage = typeof message === "string" && message.trim() ? message.trim() : "subscribeForProductAlert failed";
        const details = suffixParts.length ? ` (${suffixParts.join("; ")})` : "";
        const error = new Error(`[swym-bis] ${normalizedMessage}${details}`);
        error.swymCallbackArgs = values;
        error.swymRequestContext = context;
        return error;
      };
      if (firstDefined instanceof Error) {
        const error = withDetails(firstDefined.message || firstDefined.name);
        error.cause = firstDefined;
        return error;
      }
      if (typeof firstDefined === "string" && firstDefined.trim()) return withDetails(firstDefined);
      if (firstDefined && typeof firstDefined === "object") return withDetails($0b54f75990233cb1$var$getSwymObjectMessage(firstDefined));
      return withDetails();
    }
    function $0b54f75990233cb1$var$assertRuntime() {
      if (typeof window === "undefined") throw new Error("[swym-bis] window is unavailable");
    }
    function $0b54f75990233cb1$var$normalizeAndValidateProduct(product) {
      if (!product || typeof product !== "object") throw new Error("[swym-bis] product must be an object");
      for (const field of $0b54f75990233cb1$var$REQUIRED_PRODUCT_FIELDS) {
        if (!(field in product) || product[field] === null || product[field] === "") throw new Error(`[swym-bis] missing required product field "${field}"`);
      }
      const du = String(product.du).trim().split("#")[0].split("?")[0];
      if (!du) throw new Error("[swym-bis] product.du must be a valid canonical URL");
      return {
        epi: product.epi,
        empi: product.empi,
        du: du,
        pr: product.pr,
        iu: String(product.iu).trim()
      };
    }
    function $0b54f75990233cb1$var$validateMedium(mediumValue, medium) {
      if (!mediumValue || typeof mediumValue !== "string" || mediumValue.trim().length === 0) throw new Error("[swym-bis] mediumValue is required");
      if (!$0b54f75990233cb1$var$ALLOWED_MEDIA.has(medium)) throw new Error('[swym-bis] medium must be either "email" or "sms"');
    }
    function $0b54f75990233cb1$var$isMailingListOptInEnabled() {
      return window.MBF?.settings?.enableBackInStockMailingList === true;
    }
    function $0b54f75990233cb1$var$createSwymBisRuntime() {
      let swatRef = null;
      const availableCallbacks = new Set;
      let readyResolve;
      const readyPromise = new Promise(resolve => {
        readyResolve = resolve;
      });
      const hasBisSubscribeCapability = () => Boolean(swatRef && typeof swatRef.subscribeForProductAlert === "function");
      const setReady = swat => {
        if (!swat || swatRef) return;
        swatRef = swat;
        readyResolve();
        if (!hasBisSubscribeCapability()) return;
        availableCallbacks.forEach(callback => callback());
        availableCallbacks.clear();
      };
      if (window._swat) setReady(window._swat);
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(setReady);
      return {
        ready() {
          return readyPromise;
        },
        isAvailable() {
          return hasBisSubscribeCapability();
        },
        onAvailable(callback) {
          if (typeof callback !== "function") return () => {};
          if (hasBisSubscribeCapability()) {
            callback();
            return () => {};
          }
          availableCallbacks.add(callback);
          return () => availableCallbacks.delete(callback);
        },
        async subscribeForBackInStock({mediumValue: mediumValue, medium: medium = "email", product: product, addToMailingList: addToMailingList = 0} = {}) {
          $0b54f75990233cb1$var$validateMedium(mediumValue, medium);
          const normalizedProduct = $0b54f75990233cb1$var$normalizeAndValidateProduct(product);
          const normalizedAddToMailingList = Number(addToMailingList) === 1 ? 1 : 0;
          if (normalizedAddToMailingList === 1 && !$0b54f75990233cb1$var$isMailingListOptInEnabled()) {
            const error = new Error(`[swym-bis] ${$0b54f75990233cb1$var$MAILING_LIST_DISABLED_MESSAGE}`);
            error.userMessage = $0b54f75990233cb1$var$MAILING_LIST_DISABLED_USER_MESSAGE;
            error.swymRequestContext = {
              medium: medium,
              product: normalizedProduct,
              addToMailingList: normalizedAddToMailingList,
              topic: $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC
            };
            throw error;
          }
          await readyPromise;
          return new Promise((resolve, reject) => {
            let settled = false;
            const resolveOnce = value => {
              if (settled) return;
              settled = true;
              resolve(value);
            };
            const rejectOnceDeferred = (...errorArgs) => {
              const normalizedError = $0b54f75990233cb1$var$normalizeSwymErrorArgs(errorArgs, {
                medium: medium,
                product: normalizedProduct,
                addToMailingList: normalizedAddToMailingList,
                topic: $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC
              });
              $0b54f75990233cb1$var$deferCallback(() => {
                if (settled) return;
                settled = true;
                reject(normalizedError);
              });
            };
            swatRef.subscribeForProductAlert(mediumValue.trim(), medium, normalizedProduct, (...successArgs) => resolveOnce($0b54f75990233cb1$var$normalizeSwymSuccessArgs(successArgs)), (...errorArgs) => rejectOnceDeferred(...errorArgs), normalizedAddToMailingList, $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC);
          });
        }
      };
    }
    function $0b54f75990233cb1$export$23cdde14ed5ac142() {
      $0b54f75990233cb1$var$assertRuntime();
      window.MBF = window.MBF || {};
      if (window.MBF.swymBis) return window.MBF.swymBis;
      const runtime = $0b54f75990233cb1$var$createSwymBisRuntime();
      window.MBF.swymBis = runtime;
      return runtime;
    }
  });
  var $6ph3s = parcelRequire("6ph3s");
  var $dM4ny = parcelRequire("dM4ny");
  var $9e4lR = parcelRequire("9e4lR");
  var $hdTUn = parcelRequire("hdTUn");
  var $5SWup = parcelRequire("5SWup");
  const $47913eef6c692090$var$PRODUCT_FORM_REQUEST_CURRENT_STATE_EVENT = "product-form:request-current-state";
  var $47913eef6c692090$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("product-form")) customElements.define("product-form", class ProductForm extends HTMLElement {
      form=null;
      lowInventory=0;
      options=[];
      productData=null;
      variantData=null;
      variantMapData=null;
      productFormStateData=null;
      eventDateAggregateMapData=null;
      parentContainer=null;
      priceElements=[];
      comparePriceElements=[];
      submitButtons=[];
      stockNotifierEl=null;
      idInput=null;
      variantPickerEl=null;
      eventTermsEl=null;
      eventTermsCheckbox=null;
      eventTermsCheckboxUI=null;
      eventTermsWarning=null;
      eventTermsProperty=null;
      swymAvailabilityUnsubscribe=null;
      modalOpenStartedAt=null;
      modalSubmitterState=null;
      get currentVariant() {
        return this.findCurrentVariant();
      }
      connectedCallback() {
        this.form = this.querySelector("form");
        this.lowInventory = Number(this.dataset.lowInventory) || 0;
        this.parentContainer = this.closest("[data-product]") || this.closest(".shopify-section");
        this.stockNotifierEl = this.querySelector("stock-notifier");
        this.idInput = this.querySelector('[name="id"]');
        this.eventTermsEl = this.querySelector("[data-event-terms]");
        this.eventTermsCheckbox = this.querySelector("[data-event-terms-checkbox]");
        this.eventTermsCheckboxUI = this.querySelector("[data-event-terms-checkbox-ui]");
        this.eventTermsWarning = this.querySelector("[data-event-terms-warning]");
        this.eventTermsProperty = this.querySelector("[data-event-terms-property]");
        this.priceElements = this.parentContainer?.querySelectorAll("[data-price][data-dynamic-price]") || [];
        this.comparePriceElements = this.parentContainer?.querySelectorAll("[data-compare-at-price][data-dynamic-price]") || [];
        this.submitButtons = Array.from(this.querySelectorAll('[type="submit"]')).filter(btn => !btn.closest("stock-notifier"));
        this.variantPickerEl = this.querySelector("variant-picker");
        this.variantPickerEl?.addEventListener("variant-picker:options-change", this.onPickerOptionsChange);
        this.addEventListener($47913eef6c692090$var$PRODUCT_FORM_REQUEST_CURRENT_STATE_EVENT, this.onRequestCurrentState);
        this.eventTermsCheckbox?.addEventListener("change", this.onEventTermsChange);
        this.form?.addEventListener("submit", this.onSubmitHandler);
        this.syncEventTermsProperty();
        this.swymAvailabilityUnsubscribe = (0, $5SWup.onSwymBisAvailable)(this.onSwymBisAvailable);
        this.initializeVariant();
      }
      disconnectedCallback() {
        this.variantPickerEl?.removeEventListener("variant-picker:options-change", this.onPickerOptionsChange);
        this.removeEventListener($47913eef6c692090$var$PRODUCT_FORM_REQUEST_CURRENT_STATE_EVENT, this.onRequestCurrentState);
        this.eventTermsCheckbox?.removeEventListener("change", this.onEventTermsChange);
        this.form?.removeEventListener("submit", this.onSubmitHandler);
        this.swymAvailabilityUnsubscribe?.();
        this.swymAvailabilityUnsubscribe = null;
      }
      initializeVariant=() => {
        this.options = this.collectSelectedOptions();
        this.updateMasterId();
        this.syncUI({
          updateUrl: false
        });
      };
      onPickerOptionsChange=event => {
        const incomingOptions = Array.isArray(event.detail?.options) ? event.detail.options : [];
        const updateUrl = event.detail?.updateUrl !== false;
        this.options = incomingOptions;
        this.updateMasterId();
        this.syncUI({
          updateUrl: updateUrl
        });
      };
      onSubmitHandler=async event => {
        event.preventDefault();
        const submitter = event.submitter || this.submitButtons[0] || null;
        if (submitter?.getAttribute("aria-busy") === "true") return;
        const modalInputEl = document.querySelector('input[type="checkbox"][id^="Modal-"][data-locker]:checked');
        if (modalInputEl?.checked) modalInputEl.click();
        if (this.hasEventTermsRequirement() && !this.eventTermsCheckbox?.checked) {
          this.setEventTermsInvalidState(true);
          this.syncEventTermsProperty();
          this.eventTermsCheckbox.focus();
          return;
        }
        this.setEventTermsInvalidState(false);
        this.syncEventTermsProperty();
        if (this.currentVariant && !this.currentVariant.available && (0, $5SWup.isSwymBisAvailable)()) {
          try {
            await this.openNotifyDrawer(submitter);
          } catch (error) {
            console.warn(error);
          }
          return;
        }
        try {
          await (0, $dM4ny.addToCart)(this.form);
          this.dispatchEvent(new CustomEvent("product-form:add-success", {
            bubbles: true
          }));
        } catch (error) {
          const normalizedError = this.normalizeCartError(error);
          this.dispatchEvent(new CustomEvent("product-form:add-error", {
            bubbles: true,
            detail: normalizedError
          }));
          if (normalizedError.isValidationError) return;
          console.error("Product form submit add to cart failed:", error);
          this.form.submit();
        }
      };
      onEventTermsChange=() => {
        this.syncEventTermsProperty();
        if (this.eventTermsCheckbox?.checked) this.setEventTermsInvalidState(false);
      };
      onSwymBisAvailable=() => {
        if (!this.isConnected) return;
        this.updateStaticDespatchMessages();
        if (!this.currentVariant || this.currentVariant.available) return;
        this.updateButton("soldOut");
      };
      onRequestCurrentState=() => {
        this.emitSharedStateEvents();
      };
      loadStart=submitter => {
        if (!submitter) return;
        this.modalSubmitterState = {
          el: submitter,
          disabled: submitter.disabled,
          ariaDisabled: submitter.getAttribute("aria-disabled"),
          ariaBusy: submitter.getAttribute("aria-busy")
        };
        submitter.setAttribute("aria-busy", "true");
        submitter.setAttribute("aria-disabled", "true");
        submitter.disabled = true;
      };
      loadEnd=() => {
        if (!this.modalSubmitterState?.el) return;
        const {el: el, disabled: disabled, ariaDisabled: ariaDisabled, ariaBusy: ariaBusy} = this.modalSubmitterState;
        el.disabled = disabled;
        if (ariaDisabled === null) el.removeAttribute("aria-disabled"); else el.setAttribute("aria-disabled", ariaDisabled);
        if (ariaBusy === null) el.removeAttribute("aria-busy"); else el.setAttribute("aria-busy", ariaBusy);
        this.modalSubmitterState = null;
      };
      waitForModalResult=requestId => new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
          cleanup();
          reject(new Error(`[product-form] Timed out waiting for modal request ${requestId}`));
        }, 1e4);
        const onOpened = event => {
          if (event.detail?.requestId !== requestId) return;
          cleanup();
          resolve(event.detail);
        };
        const onFailed = event => {
          if (event.detail?.requestId !== requestId) return;
          cleanup();
          reject(event.detail?.error || new Error("[product-form] Modal open failed"));
        };
        const cleanup = () => {
          clearTimeout(timeout);
          window.removeEventListener((0, $9e4lR.MODAL_OPENED_EVENT), onOpened);
          window.removeEventListener((0, $9e4lR.MODAL_OPEN_FAILED_EVENT), onFailed);
        };
        window.addEventListener((0, $9e4lR.MODAL_OPENED_EVENT), onOpened);
        window.addEventListener((0, $9e4lR.MODAL_OPEN_FAILED_EVENT), onFailed);
      });
      openNotifyDrawer=submitter => {
        const variantId = this.currentVariant?.id;
        if (!variantId || !this.dataset.url) return;
        const readiness = (0, $hdTUn.getModalOrchestratorReadiness)();
        if (!readiness.ready) {
          const error = new Error(`[product-form] Cannot open notify drawer: ${readiness.reason}`);
          console.error(error.message, {
            variantId: variantId,
            baseUrl: this.dataset.url,
            reason: readiness.reason
          });
          return Promise.reject(error);
        }
        const requestId = (0, $9e4lR.createModalRequestId)();
        const strategy = this.hasAttribute("data-modal") ? "stack" : "replace";
        this.loadStart(submitter);
        this.modalOpenStartedAt = performance.now();
        window.dispatchEvent(new CustomEvent((0, $9e4lR.MODAL_OPEN_REQUEST_EVENT), {
          detail: {
            requestId: requestId,
            baseUrl: this.dataset.url,
            view: "notify-drawer",
            params: {
              variant: variantId
            },
            strategy: strategy,
            context: "product-form",
            source: {
              type: "product-form",
              id: this.getAttribute("form") || null,
              formId: this.getAttribute("form") || null,
              productId: this.dataset.productId || null,
              context: "product-form"
            }
          }
        }));
        return this.waitForModalResult(requestId).then(result => result).catch(error => {
          throw error;
        }).finally(() => {
          this.loadEnd();
          this.modalOpenStartedAt = null;
        });
      };
      syncUI=({updateUrl: updateUrl}) => {
        this.updatePrice();
        this.updateInventory();
        this.updateStockNotifier();
        this.updateDespatchAndPromiseDate();
        if (updateUrl) this.updateURL();
        this.updateVariantSku();
        const variantSummary = this.getCurrentVariantSummary();
        this.updateButton(this.currentVariant?.available ? "available" : "soldOut");
        this.updateStaticDespatchMessages();
        this.emitSharedStateEvents({
          variantSummaryOverride: variantSummary
        });
      };
      updateMasterId=() => {
        if (this.idInput) this.idInput.value = this.currentVariant?.id || "";
        this.querySelectorAll("[data-variant-title]").forEach(el => el.dataset.variantTitle = this.currentVariant?.title || "");
        this.querySelectorAll("[data-variant-sku]").forEach(el => el.dataset.variantSku = this.currentVariant?.sku || "");
      };
      updatePrice=() => {
        const productData = this.getProductData();
        const price = this.currentVariant?.price ?? productData.price;
        const compareAtPrice = this.currentVariant?.compare_at_price ?? productData.compare_at_price;
        const isOnSale = compareAtPrice > price;
        this.priceElements.forEach(el => {
          el.innerHTML = (0, $6ph3s.default)(price, window.Shopify.currency.active);
        });
        this.comparePriceElements.forEach(el => {
          el.innerHTML = isOnSale ? (0, $6ph3s.default)(compareAtPrice, window.Shopify.currency.active) : "";
        });
      };
      updateInventory=() => {
        const inventory = this.querySelector("[data-inventory]");
        if (!inventory) return;
        const variant = this.currentVariant;
        inventory.innerText = this.lowInventory && variant && variant.inventory_quantity > 0 && variant.inventory_quantity <= this.lowInventory && variant.inventory_management === "shopify" && variant.inventory_policy === "deny" ? window.MBF.strings?.inventory?.only?.replace("{{ count }}", variant.inventory_quantity) : "";
      };
      updateButton=status => {
        const variantSummary = this.getCurrentVariantSummary();
        const summaryButton = variantSummary?.button || null;
        const useNotifyCta = status === "soldOut" && (0, $5SWup.isSwymBisAvailable)();
        const config = {
          available: {
            text: window.MBF.strings.addToCart,
            disabled: false
          },
          soldOut: {
            text: window.MBF.strings.soldOut,
            disabled: true
          },
          notify: {
            text: window.MBF.strings?.outOfStock?.notifyLong || "Translation missing: en.product.out_of_stock.notify_long",
            disabled: false
          }
        };
        const fallback = useNotifyCta ? config.notify : config[status];
        const text = useNotifyCta ? fallback.text : summaryButton?.text || fallback.text;
        const disabled = !useNotifyCta && typeof summaryButton?.disabled === "boolean" ? summaryButton.disabled : fallback.disabled;
        this.submitButtons.forEach(button => {
          const textEl = button.querySelector("[data-atc-text]");
          const priceEl = button.querySelector("[data-atc-price]");
          (textEl || button).textContent = text;
          if (priceEl) {
            const showPrice = !disabled && !useNotifyCta;
            priceEl.classList.toggle("flex", showPrice);
            priceEl.classList.toggle("hidden", !showPrice);
          }
          if (button.closest("[data-sticky]")) return;
          button.disabled = disabled;
          button.classList.toggle("btn--primary", !disabled);
          button.classList.toggle("btn--secondary", disabled);
        });
      };
      updateDespatchAndPromiseDate=() => {
        const despatchDateInput = this.querySelector('[name="properties[Despatches]"]');
        const actualPromiseDateInput = this.querySelector('[name="properties[__Promise Date]"]');
        const variantSummary = this.getCurrentVariantSummary();
        if (despatchDateInput) {
          const despatchDate = variantSummary?.despatch_date || "";
          despatchDateInput.value = despatchDate;
          if (despatchDate) despatchDateInput.disabled = false; else despatchDateInput.disabled = true;
        }
        if (actualPromiseDateInput) {
          const actualPromiseDate = variantSummary?.actual_promise_date || "";
          actualPromiseDateInput.value = actualPromiseDate;
          if (actualPromiseDate) actualPromiseDateInput.disabled = false; else actualPromiseDateInput.disabled = true;
        }
      };
      updateURL=() => {
        if (!this.hasAttribute("data-url")) return;
        if (this.getVariantData().length <= 1 || !this.currentVariant || this.hasAttribute("data-modal") || this.submitButtons.length === 0) return;
        const url = new URL(window.location.href);
        url.searchParams.set("variant", this.currentVariant.id);
        const newUrl = `${this.dataset.url}${url.searchParams.toString() ? `?${url.searchParams}` : ""}`;
        window.history.replaceState({
          path: newUrl
        }, "", newUrl);
      };
      updateStockNotifier=() => {
        if (!this.stockNotifierEl) return;
        const isHidden = !this.currentVariant || this.currentVariant.available;
        this.stockNotifierEl.classList.toggle("hidden", isHidden);
        this.stockNotifierEl.setAttribute("aria-hidden", isHidden);
      };
      updateVariantSku=() => {
        const sku = this.currentVariant?.sku || "";
        this.querySelectorAll("[data-variant-sku]").forEach(el => {
          el.textContent = sku;
          el.dataset.variantSku = sku;
        });
      };
      updateStaticDespatchMessages=() => {
        const bisAvailable = (0, $5SWup.isSwymBisAvailable)();
        const notifyText = window.MBF?.strings?.outOfStock?.notifyLong || "Translation missing: en.product.out_of_stock.notify_long";
        const containers = Array.from(this.querySelectorAll("[data-static-despatch-message]"));
        containers.forEach(messageEl => {
          const isNotifyMessage = messageEl.dataset.staticDespatchIsNotify === "true";
          if (!isNotifyMessage) return;
          messageEl.textContent = bisAvailable ? notifyText : "";
        });
      };
      hasEventTermsRequirement=() => Boolean(this.eventTermsEl && this.eventTermsCheckbox);
      syncEventTermsProperty=() => {
        if (!this.eventTermsProperty || !this.eventTermsCheckbox) return;
        this.eventTermsProperty.value = this.eventTermsCheckbox.checked ? "true" : "false";
      };
      setEventTermsInvalidState=isInvalid => {
        if (!this.hasEventTermsRequirement()) return;
        this.eventTermsEl.classList.toggle("is-invalid", isInvalid);
        this.eventTermsCheckbox.setAttribute("aria-invalid", String(isInvalid));
        this.eventTermsWarning?.classList.toggle("hidden", !isInvalid);
        if (this.eventTermsCheckboxUI) {
          this.eventTermsCheckboxUI.classList.toggle("border-red", isInvalid);
          this.eventTermsCheckboxUI.classList.toggle("border-scheme-border", !isInvalid);
        }
      };
      normalizeCartError=error => {
        const status = Number(error?.status) || null;
        const description = error?.description;
        const rawErrors = error?.errors || (description && typeof description === "object" ? description : null);
        const errors = rawErrors && typeof rawErrors === "object" ? rawErrors : null;
        const baseMessage = (typeof error?.message === "string" && error.message !== "[object Object]" ? error.message : null) || (typeof description === "string" ? description : null) || window.MBF?.strings?.errorMessage || "Unable to add this item to your basket.";
        return {
          status: status,
          message: baseMessage,
          errors: errors,
          error: error,
          isValidationError: status === 422
        };
      };
      resolveImageUrl=image => {
        if (!image) return "";
        if (typeof image === "string") return image;
        if (typeof image === "object") return image.src || image.url || "";
        return "";
      };
      buildSharedVariantPayload=({variantSummaryOverride: variantSummaryOverride} = {}) => {
        const variant = this.currentVariant || null;
        const productData = this.getProductData();
        const variantSummary = variantSummaryOverride !== undefined ? variantSummaryOverride : this.getCurrentVariantSummary();
        const productUrl = this.dataset.url || productData?.url || window.location.pathname;
        const variantImage = this.resolveImageUrl(variant?.featured_image) || this.resolveImageUrl(productData?.featured_image);
        return {
          product: {
            id: this.dataset.productId || productData?.id || null,
            title: this.dataset.productTitle || productData?.title || "",
            url: productUrl
          },
          productId: this.dataset.productId || productData?.id || null,
          variant: variant,
          variantSummary: variantSummary,
          options: [ ...this.options ],
          notify: {
            product: variant ? {
              epi: variant.id,
              empi: this.dataset.productId || productData?.id || null,
              du: productUrl,
              pr: variant.price,
              iu: variantImage
            } : null
          }
        };
      };
      emitSharedStateEvents=({variantSummaryOverride: variantSummaryOverride} = {}) => {
        const sharedPayload = this.buildSharedVariantPayload({
          variantSummaryOverride: variantSummaryOverride
        });
        const {product: product, productId: productId, variant: variant, variantSummary: variantSummary, options: options, notify: notify} = sharedPayload;
        this.dispatchEvent(new CustomEvent("product-form:state-updated", {
          bubbles: true,
          detail: {
            variant: variant,
            variantSummary: variantSummary,
            options: options,
            productId: productId,
            product: product,
            notify: notify,
            payload: sharedPayload
          }
        }));
        this.dispatchEvent(new CustomEvent("variant:change", {
          bubbles: true,
          detail: {
            variant: variant,
            variantSummary: variantSummary,
            options: options,
            productId: productId,
            product: product,
            notify: notify,
            payload: sharedPayload
          }
        }));
      };
      findCurrentVariant=() => {
        const variants = this.getVariantData();
        return variants.length === 1 ? variants[0] : variants.find(variant => !variant.options.some((option, index) => this.options[index] !== option));
      };
      collectSelectedOptions=() => Array.from(this.querySelectorAll('select[name^="option"],input[name^="option"]:checked'), el => el.value);
      getProductData=() => {
        if (!this.productData) {
          const el = this.querySelector('[type="application/json"][data-product-json]') || this.querySelector('[type="application/json"]');
          this.productData = JSON.parse(el.textContent);
        }
        return this.productData;
      };
      getVariantData=() => {
        if (!this.variantData) {
          const el = this.querySelector('[type="application/json"][data-variant-json]');
          this.variantData = el ? JSON.parse(el.textContent) : this.getProductData().variants;
        }
        return this.variantData;
      };
      getVariantMapData=() => {
        if (!this.variantMapData) {
          const el = this.querySelector('[type="application/json"][data-variant-map]');
          this.variantMapData = el ? JSON.parse(el.textContent) : {};
        }
        return this.variantMapData;
      };
      getCurrentVariantSummary=() => {
        const variant = this.currentVariant;
        if (!variant) return null;
        const variantMap = this.getVariantMapData();
        return variantMap?.[variant.id] || variantMap?.[String(variant.id)] || null;
      };
      getProductFormStateData=() => {
        if (!this.productFormStateData) {
          const el = this.querySelector('[type="application/json"][data-product-form-state]');
          this.productFormStateData = el ? JSON.parse(el.textContent) : {};
        }
        return this.productFormStateData;
      };
      getEventDateAggregateMapData=() => {
        if (!this.eventDateAggregateMapData) {
          const el = this.querySelector('[type="application/json"][data-event-date-aggregate-map]');
          this.eventDateAggregateMapData = el ? JSON.parse(el.textContent) : {};
        }
        return this.eventDateAggregateMapData;
      };
    });
  })();
})();